import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-project-viewer',
  imports: [],
  templateUrl: './project-viewer.component.html',
  styleUrl: './project-viewer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectViewerComponent { }
